export const SuspenseLoading = ({ className }: { className?: string }) => {
  return (
    <div
      className={`absolute inset-0 z-10 flex h-[130%] w-full animate-pulse items-center justify-center rounded-2xl bg-gray-50/50 ${className}`}>
      <div className="mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
    </div>
  );
};
